import { useQuery } from '@tanstack/react-query';
import { useListScheduledReports } from 'hooks/api/reports';
import { ScheduledStockBalanceReport } from 'contracts/scheduledRepports';
import { DataTable } from 'components/ui/DataTable';
import { getColumns } from './columns';

const columns = getColumns();

export const UnloadingOrders = () => {
  const { listReports } =
    useListScheduledReports<ScheduledStockBalanceReport>();

  const reportsQuery = useQuery({
    queryKey: ['list-unloading-orders-reports'],
    queryFn: () =>
      listReports({
        type: 'unloading-orders',
      }),
    initialData: [],
  });

  return (
    <section className="w-full h-auto">
      <DataTable
        data={reportsQuery?.data ?? []}
        columns={columns}
        showControlColumns={false}
        isLoading={reportsQuery.isLoading}
      />
    </section>
  );
};
